import { useQuery } from '@apollo/client';
import { usePaginationAndFilter } from 'components/template/ListTemplate/hooks/usePaginationAndFilter';
import { GRAPHQL_BUSCAR_UNIDADE_FATURA_PRE_PAGO } from 'gql/unidadeFatura';
import { useEffect, useMemo } from 'react';
import JSON_DATA_FILTER from '../../data/filter.json';
import { IQueryUnidadeFaturaPrePago } from './index.d';
export const useQueryFilterHistorico = () => {
    const dataSelectHeader = useMemo(() => JSON_DATA_FILTER, []);

    const props = usePaginationAndFilter({
        dataKeyName: null,
        keysQueryVariavel: [],
    });

    const { loading } = useQuery<IQueryUnidadeFaturaPrePago>(
        GRAPHQL_BUSCAR_UNIDADE_FATURA_PRE_PAGO,
        {
            context: props.context,
            variables: props.variables,
            onCompleted: ({ unidadeFaturaPrePago }) =>
                props.onCompleted(unidadeFaturaPrePago),
            onError: props.onError,
        }
    );

    useEffect(() => {
        props.setLoading(loading);
    }, [loading]);

    return { ...props, dataSelectHeader };
};
